import React from 'react';
import {fromJS} from 'immutable';
import {PageWrapper} from '../../components';
import {ModalsAction, PriceAlertsAction} from '../../actions';
import PriceAlertsWrapper from './PriceAlertsWrapper';
import ResolveAlertModal from './ResolveAlertModal';
import SkipAlertModal from './SkipAlertModal';
import AlertHistoryModal from './AlertHistoryModal';

export default class PriceAlerts extends React.Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    ModalsAction.add(100); // Resolve Alert Modal
    ModalsAction.add(101); // Skip Alert Dialog
    ModalsAction.add(102); // Alert History Modal
    ModalsAction.add(103); // Bulk Skip Alert Dialog
  }

  render() {
    return (
      <PageWrapper>
        <PriceAlertsWrapper route={this.props.route} location={this.props.location} />
        <ResolveAlertModal 
          id={100}
          title="Resolve Price Alert"
          location={this.props.location}
          onHide={this.handleCloseModal.bind(this, 100)}
        />
        <SkipAlertModal
          id={101}
          title="Skip Price Alert"
          location={this.props.location}
          onHide={this.handleCloseModal.bind(this, 101)}
        />
        <SkipAlertModal
          id={103}
          title="Bulk Skip Price Alerts"
          location={this.props.location}
          onHide={this.handleCloseModal.bind(this, 103)}
          isBulkMode={true}
        />
        <AlertHistoryModal
          id={102}
          title="Alert Change History"
          onHide={this.handleCloseModal.bind(this, 102)}
        />
      </PageWrapper>
    );
  }

  handleCloseModal(modalId) {
    ModalsAction.hide(modalId);
  }

  handleRefresh() {
    PriceAlertsAction.fetchAll();
  }
}
